import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import MuiLinearProgress from "../components/controls/LinearProgress";

const useStyles = makeStyles({
  rootBox: {
    "&.MuiBox-root": {
      marginTop: "0",
      marginBottom: "-25px",
      display: "flex",
      alignItems: "center",
    },
  },
  skillTitle: {
    "&.MuiTypography-root": {
      fontSize: "2.5rem",
      fontWeight: "400",
      lineHeight: "3.5rem",
    },
  },
  percentage: (props) => ({
    "&.MuiTypography-root": {
      color: props.color,
    },
  }),
});

function SkillsAnimationProgress(props) {
  const { skillName, color, value } = props;
  const classes = useStyles(props);
  const [progress, setProgress] = useState(value);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= value ? 0 : prevProgress + 5
      );
    }, 300);
    return () => {
      clearInterval(timer);
    };
  }, [value]);

  return (
    <>
      <Typography className={classes.skillTitle} variant="h2">
        {skillName}
      </Typography>
      <Box className={classes.rootBox}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <MuiLinearProgress
            color={color}
            variant="determinate"
            value={progress}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography
            className={classes.percentage}
            variant="h6"
          >{`${Math.round(progress)}%`}</Typography>
        </Box>
      </Box>
    </>
  );
}

export default SkillsAnimationProgress;
